import { useI18n } from "@/locales/client";
import { useRouter } from "next/navigation";

export const useHomeTrack=()=>{
  const router = useRouter();
    const t = useI18n();
    const handleRedirect = (type: string, slug: string) => {
      router.push(`/collection/${type}/${slug}`);
    };

    return{
      t,
      handleRedirect
    }
}

